var _defs, _polygon, _path, _path2, _path3, _polygon2, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1174 373.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0072bb;\n      }\n\n      .cls-2 {\n        fill: #ec1c24;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1174 266.02 1158 352.01 904 352.01 961 27.04 1066 27.04 1025 261.02 1174 261.02 1174 266.02"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165,8.04c42.82,3.59,87.7,19.73,129.81,28.69,53,11.27,107.03,14.13,157.18-9.69l-16.25,91.73c-16.69,7.42-34.39,13.14-52.53,15.97-101.7,15.86-192.69-50.27-294.39-31.39-16.54,3.07-32.1,8.96-47.81,14.68L57.53,27.07c13.33-6.73,27.87-11.36,42.46-14.54,6.79-1.48,17.41-3.86,24.01-4.49,0,0,22.41-1.31,41,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,349.01l14.32-79.18,2.69-10.31c15.64-6.66,31.98-12.27,48.81-15.19,101.94-17.7,192.9,48.56,295.39,31.39,16.87-2.83,32.83-8.92,48.79-14.7l-15.22,90.76c-22.79,10.24-85.41,29.09-170.35,9.6l-52.84-13.7C73.76,324.7,0,351.01,0,351.01v-2h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.99,144.03l-15.16,90.82c-18.16,8.27-37.61,14.28-57.47,17.02-93.36,12.89-179.05-43.87-271.85-34.85-22.58,2.2-45.03,8.45-65.5,17.99l15.91-91.33c17.63-8.76,38.12-14.95,57.71-17.53,98.92-13.04,187.48,49.92,287.56,32.55,16.9-2.93,32.99-8.31,48.81-14.68h0Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "924 27.04 865.5 352.01 762 352.01 819.5 27.04 924 27.04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M684.54,27l-186.08-.03-58.46,325.04h0s103.5.01,103.5.01c4.07,0,12.12-73.05,15.64-79.86,35.87-1.93,73.2,4.22,108.08-5.42,116.52-32.19,162.13-220.55,17.32-239.74ZM648.48,174.01c-2.9,2.26-11.63,7.02-14.98,7.02h-58.5l11.58-64.05c16.81,1.13,35.18-1.38,51.79.19,32.35,3.05,31.42,40.19,10.11,56.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPil);
export default __webpack_public_path__ + "static/media/pil.fa256fba5d9796d251723b7b04f48486.svg";
export { ForwardRef as ReactComponent };